import { getDemoData, matchRestRequest } from '../utils'

export const mockGetDuplicateShifts = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/shift_duplicate_recommendations_e8aed0ad',
      'POST'
    ),
  getResponse: async () => {
    const demoData = getDemoData()
    return {
      data: {
        company: {
          shiftDuplicateRecommendations: demoData.shifts.slice(
            demoData.shifts.length - 10
          ),
        },
      },
    }
  },
}
